import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const CustomSwitch = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
      color: 'var(--switch-handle-on)',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'var(--switch-on-bg)',
      opacity: 1,
    },
    '& .MuiSwitch-switchBase': {
      color: 'var(--switch-handle-off)',
    },
    '& .MuiSwitch-track': {
      backgroundColor: 'var(--switch-off-bg)',
      opacity: 1,
    },
}));

export default CustomSwitch;
